export const ADD_ITEM_TO_ORDER = "ADD_ITEM_TO_ORDER" 
export const ADD_ITEM_TO_CART = "ADD_ITEM_TO_CART" 
export const REMOVE_ITEM_FROM_CART = "REMOVE_ITEM_FROM_CART" 
export const EDIT_ITEM_IN_ORDER = "EDIT_ITEM_IN_ORDER" 
export const ADD_SUBTOTAL = "ADD_SUBTOTAL" 
